import React from "react";
import { DocAccountMap, DocAccountProps } from "../../Language";
import { AgreementAccountSV as SV } from "./AgreementAccountSV";
import "../../Documents.css";

const docsMap: DocAccountMap = { SV };

export const AgreementAccount: React.FC<DocAccountProps> = (props) =>
  React.createElement(docsMap[props.language], props);
